import { Injectable } from '@angular/core';
import { ClientRef } from '../../domain/models/client-ref.model';
import { ClientRefDto } from '../dtos/client-ref.dto';

@Injectable()
export class ClientRefMapper {
  public toClientRef(dto: ClientRefDto): ClientRef {
    return {
      id: dto.ExternalId,
      fullName: this.resolveFullName(dto),
      phone: dto.Phone ?? null,
      patients: (dto.Patients ?? []).map((patient) => ({
        id: patient.ExternalId,
        name: patient.Name,
        speciesId: patient.SpeciesId ?? null,
        breedId: patient.BreedId ?? null,
        dateOfBirth: patient.DateOfBirth ?? null,
        pictureThumb: patient.PictureThumb ?? null,
        pictureMedium: patient.PictureMedium ?? null,
      })),
    };
  }

  private resolveFullName(dto: ClientRefDto): string {
    const fullName = dto.FullName?.trim();
    if (fullName) return fullName;

    const combined = [dto.FirstName, dto.LastName].filter(Boolean).join(' ').trim();
    if (combined) return combined;

    return dto.Email ?? '';
  }
}
